// VideoHelpModal.js
import React from "react";
import "../../styles/VideoHelpModal.css";

const VideoHelpModal = ({ open, onClose, message, videoUrl }) => {
  if (!open) return null;

  return (
    <div className="video-help-modal-overlay" onClick={onClose}>
      <div className="video-help-modal" onClick={(e) => e.stopPropagation()}>
        <div className="video-help-modal-header">
          <h3>{message}</h3>
          <button className="video-help-close-button" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="video-help-modal-content">
          <iframe
            src={videoUrl}
            title="Help Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default VideoHelpModal;
